import React, { useRef } from "react";
import { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import Copyright from "./components/Footer/Copyright";
import Headers from "./components/Header/Header";
import AboutMe from "./components/Section/About/AboutMe";
import Heading from "./assistent/Heading";
import Land from "./components/Header/Land";
import Certification from "./components/Section/Certifcates/Certification";
import Projects from "./components/Section/Projects/Projects";
import About from "./components/Section/About/About";
import Skills from "./components/Section/Skills/Skills";
import Skill from "./components/Section/Skills/Skill";
import ScrollToTop from "react-scroll-to-top";
import Contact from "./components/Section/Contact/Contact";
import Dealing from "./components/Section/Dealing/Dealing";

//import { Router } from "react-router-dom";

function App() {
  const ref = useRef(null);
  React.useEffect(() => {
    import("@lottiefiles/lottie-player");
  });
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div className="App">
      <Headers />
      <Land />
      <Heading heading="ABOUT ME" />
      <AboutMe />
      <About />
      <Certification id="certification" />
      <Heading heading="Skills" />
      <Skills />
      <Skill/>
      <Dealing/>
      <Heading heading="Projects" />
      <Projects />
      <Contact/>
      <Copyright />
      <ScrollToTop smooth  style={{width:"150px",height:"150px",backgroundColor:"unset",boxShadow:"unset" }} component={ <lottie-player
              id="firstLottie"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src="https://assets5.lottiefiles.com/packages/lf20_4tg3fb79.json"
              
            ></lottie-player>} />

    </div>
  );
}

export default App;
